import { PromotionEffectType } from "@scayle/storefront-nuxt";
export const isGiftConditionMet = (promotion, applicablePromotions) => {
  return applicablePromotions?.some(
    (applicablePromotion) => applicablePromotion.promotion.id === promotion.id
  ) || false;
};
export const isBuyXGetYType = (promotion) => {
  return promotion?.effect?.type === PromotionEffectType.BUY_X_GET_Y;
};
export const isAutomaticDiscountType = (promotion) => {
  return promotion?.effect?.type === PromotionEffectType.AUTOMATIC_DISCOUNT;
};
export const getVariantIds = (promotion) => {
  if (!isBuyXGetYType(promotion) || !promotion) {
    return [];
  }
  const { additionalData } = promotion.effect;
  return additionalData.variantIds;
};
export const isFreeGiftBasketItem = (basketItem) => {
  return !!basketItem.promotion?.isValid && isBuyXGetYType(basketItem.promotion);
};
export const sortPromotionsByPriority = (a, b) => {
  return a.priority - b.priority;
};
